import { useEffect, useRef } from 'react';
// Mesmo CSS do widget real (agents/public/chat.css); o teste do widget garante que as duas cópias são iguais.
import chatCss from './widget-chat.css?raw';

export interface PreviewAppearance {
  color: string; title: string; subtitle: string; greeting: string; intro: string; description: string;
  suggestions: string[]; position: 'left' | 'right'; avatarUrl: string;
}

const esc = (s: string) => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
const ICON_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
const ICON_UP = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';

/** Mesmo HTML que agents/src/client/chat.ts monta na tela de boas-vindas; todo texto passa por esc(). */
export function previewHtml(a: PreviewAppearance) {
  const color = /^#[0-9a-f]{6}$/i.test(a.color) ? a.color : '#00684A';
  const initial = esc((a.title.trim()[0] || '?').toUpperCase());
  const photo = (img: string, ini: string) => (a.avatarUrl.startsWith('https://')
    ? `<img class="${img}" src="${esc(a.avatarUrl)}" alt="" referrerpolicy="no-referrer">`
    : `<span class="${ini}">${initial}</span>`);
  const chips = a.suggestions.map((s) => s.trim()).filter(Boolean).map((s) => `<button type="button">${esc(s)}</button>`).join('');
  return `<style>${chatCss}</style>
<div id="app" style="--brand:${color};height:620px;border-radius:16px;overflow:hidden;box-shadow:0 12px 40px rgba(0,30,43,.2)">
  <header>
    <div class="brand"><span class="photo">${photo('', 'initial')}</span>
      <div class="titles"><strong>${esc(a.title)}</strong><span class="sub">${esc(a.subtitle)}</span></div></div>
    <button class="close" type="button" aria-label="Fechar">${ICON_X}</button>
  </header>
  <main><section class="welcome">${photo('photo-lg', 'initial-lg')}
    ${a.intro ? `<span class="hi">${esc(a.intro)}</span>` : ''}
    <h1>${esc(a.greeting)}</h1>
    ${a.description ? `<p>${esc(a.description)}</p>` : ''}
    ${chips ? `<div class="chips">${chips}</div>` : ''}
  </section></main>
  <form class="composer"><textarea rows="1" placeholder="Pergunte ou fale com a gente…" aria-label="Mensagem" disabled></textarea><button type="button" disabled aria-label="Enviar">${ICON_UP}</button></form>
  <p class="disclaimer">Respostas geradas por IA podem conter erros.</p>
</div>`;
}

/** Prévia fiel do widget: shadow DOM isola o CSS do widget do tema do app. */
export function WidgetPreview({ a }: { a: PreviewAppearance }) {
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = host.current;
    if (!el) return;
    const root = el.shadowRoot ?? el.attachShadow({ mode: 'open' });
    root.innerHTML = previewHtml(a);
  }, [a]);
  return (
    <section className="brand-card" style={{ background: '#E9EEF1' }}>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>Prévia</div>
      <div ref={host} style={{ maxWidth: 380, marginLeft: a.position === 'left' ? 0 : 'auto' }} />
    </section>
  );
}
